// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__g2Mxy","label":"Completed_label__2XrzE"};